import React from 'react'
import { Modal, ModalHeader, ModalBody, Label } from 'reactstrap'
import Moment from 'moment'
import ReactTable from 'react-table'

import Lang from 'Lang/General'

const EmailLogsModal = props => {
  return(
    <Modal size='md' isOpen={ props.showEmailLogsModal } >
      <ModalHeader toggle={ () => props.onChangeAutomationHOC( 'showEmailLogsModal', false ) } >
        { Lang[ 'EMAIL_LOGS' ][ props.data.languageReducer.userSettings.admin_panel_language ] }
      </ModalHeader>
      <ModalBody>
        {
          props.selectedAutomationEmailLogs.map( automationEmailFair => (
            automationEmailFair.logs.map( ( automationEmailLogs, index ) => (
              <div className='mb-4' >
                <Label 
                  className='mb-2'
                  style={{ fontWeight: "bold", fontSize: "120%" }} >
                  {(
                    automationEmailFair.fair_name + ' ' +
                    `${ Lang[ 'EMAIL' ][ props.data.languageReducer.userSettings.admin_panel_language ] } ${ index + 1 } ` +
                    Lang[ 'IS_SENT_OUT_ON' ][ props.data.languageReducer.userSettings.admin_panel_language ] + ' ' +
                    Moment( automationEmailLogs.last_sent_out || '' ).format( 'HH:mm DD/MM/YY' )
                  )}
                </Label>
                <ReactTable
                  showPagination={ true }
                  pageSize={ 10 }
                  NoDataComponent={ () => <span></span> }
                  data={ automationEmailLogs.users }
                  columns={[
                    {
                      Header: Lang[ 'EMAIL' ][ props.data.languageReducer.userSettings.admin_panel_language ],
                      accessor: 'email'
                    },
                    {
                      Header: Lang[ 'COMPANY_NAME' ][ props.data.languageReducer.userSettings.admin_panel_language ],
                      accessor: 'company'
                    }
                  ]} 
                />
              </div>
            )) 
          ))
        }
      </ModalBody>
    </Modal>
  )
}

export default EmailLogsModal